import {styled, IconButton, alpha, Typography, Icon} from '@mui/material';
import {StyledCard} from 'presentation/components/StyledCard';

const CustomStyledCardContainer = styled(StyledCard.Container)`
	${({theme}) => theme.breakpoints.down('sm')} {
		border-radius: 8px;
	}
`;

const IconButtonStyled = styled(IconButton)`
	background-color: ${({theme}) => alpha(theme.palette.primary.main, 0.08)};
`;

const StyledFileName = styled(Typography)`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const StyledIcon = styled(Icon)`
	min-width: 20px;
	min-height: 20px;
`;

export {CustomStyledCardContainer, IconButtonStyled, StyledFileName, StyledIcon};
